import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import ImageSideContainer from "../../components/ImageSideContainer";
import { Icon } from "../../components/Icon";

type props = {
  message: string;
};

const ErrorPage: FunctionComponent<props> = ({ message }) => {
  const navigate = useNavigate();
  return (
    <>
      <ImageSideContainer>
        <section className="notFound">
          <header className="notFound__header">
            <Icon iconName="broken_chain" className="notFound__icon" />
            <h2 className="notFound__title">Algo salió mal</h2>
          </header>
          <div className="notFound__description">
            <p>{message}</p>
            <button onClick={() => navigate("/")}>Volver al inicio</button>
          </div>
        </section>
      </ImageSideContainer>
    </>
  );
};

export default ErrorPage;
